import { AppRoutes } from "../common/AppsRouter"
import { log } from "../common/Logging"
import { StudentStoreSA } from "../react/students/StudentStoreSA"
import { Coor } from "./activities/maze/MazeGrid"

export class BabUtils {
    static degreeToRadian = (degree: number) => {
        if (degree < -360 || degree > 360) {
            throw new Error(`${degree} is outside the range of a degree`)
        }
        return (degree * Math.PI) / 180
    }

    static sharedCreateFunctions = async () => {
        if (StudentStoreSA.instance.student == null) {
            log.warn(
                "Tried to enter a babylon activity, but student is undefined.",
            )
            window.location.replace(AppRoutes.home)
            return
        }
    }

    static manhattanDistance = (p1: Coor, p2: Coor) => {
        const xDist = Math.abs(p1.x - p2.x)
        const yDist = Math.abs(p1.z - p2.z)
        return xDist + yDist
    }
}

interface TimerAction {
    startAt: number
    action: () => void
    id?: number
}

interface LoopInfo extends TimerAction {
    intervalDuration: number
    timeoutId?: number
}

export class BabTimer {
    static create = () => new BabTimer()

    private actions: Array<TimerAction> = []
    private loops: Array<LoopInfo> = []

    add = (startAt: number, action: () => void) => {
        this.actions.push({ startAt, action })
    }

    loop = (intervalDuration: number, action: () => void, startAt = 0) => {
        this.loops.push({ intervalDuration, action, startAt })
    }

    start = () => {
        this.actions.forEach((action) => {
            action.id = window.setTimeout(action.action, action.startAt)
        })
        this.loops.forEach((loop) => {
            loop.timeoutId = window.setTimeout(() => {
                loop.id = window.setInterval(loop.action, loop.intervalDuration)
            }, loop.startAt)
        })
    }

    cancel = () => {
        this.loops.forEach((loop) => {
            clearInterval(loop.id)
            clearTimeout(loop.timeoutId)
        })
        this.actions.forEach((timer) => clearTimeout(timer.id))
    }
}
